import { CategoryId } from 'interfaces/meta'
import { BalanceType } from 'interfaces/accounts'
import { ASSET_OTHER_CATEGORY_ID, INVESTMENT_CATEGORY_ID } from 'constants/meta'
import { AccountLinkStatus } from 'interfaces/linkage'

export const BALANCES_TITLES_MAP: Record<BalanceType, string> = {
  cash_balances: 'Cash Balances',
  investments: 'Investments',
  credit_cards: 'Credit Card Balances',
  other_loans: 'Other Loans',
}

export const BALANCE_TYPES_ORDER: BalanceType[] = [
  'cash_balances', 'investments', 'credit_cards', 'other_loans',
]

export const ALL_DEBTS_TRACKER_CATEGORY_NAME = 'All Debts'
export const ALL_ASSETS_TRACKER_CATEGORY_NAME = 'All Assets'

export const NOT_APPLICABLE = `N/A`
export const NOT_PRESENTED = `Not presented`
export const UNLINKED = 'Unlinked'

export const NO_BALANCES_LABEL = 'No balances available for the selected time period'

export const CATEGORY_WORDING_MAP: Record<CategoryId, string> = {
  savings: 'cash or savings',
  investment: 'investment',
  creditcard: 'credit card',
  debt_other: 'personal or other loan',
  asset_other: 'other asset',
  mortgage: 'mortgage',
  home_equity: 'home equity loan',
  debt_auto: 'auto loan',
  student: 'student loan',
  cd: 'CD',
  home: 'homes',
  asset_auto: 'cars',
}

export const NO_INTEREST_CATEGORIES: Set<CategoryId> = new Set(['home', 'asset_auto'])

export const CATEGORIES_WITHOUT_EFFECTIVE_RATE = new Set([INVESTMENT_CATEGORY_ID, ASSET_OTHER_CATEGORY_ID])

export const INACTIVE_LINK_STATUS: AccountLinkStatus = 'inactive'
